import { render, staticRenderFns } from "./modal.vue?vue&type=template&id=35ec9a62&scoped=true&"
import script from "./modal.vue?vue&type=script&setup=true&lang=js&"
export * from "./modal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./modal.vue?vue&type=style&index=0&id=35ec9a62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ec9a62",
  null
  
)

export default component.exports